module.exports = __webpack_public_path__ + "static/img/zs-04.362093b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs-04.png
// module id = YNx2
// module chunks = 16